import React from 'react';
import { COMMON_TEXT } from '@/helpers/common-text';
import { Tooltip } from 'primereact/tooltip';
import { generateRandomString } from '@/helpers/utility';
import { format } from 'date-fns';

// V3 Employee Marker with actual employee profile images
export const EmployeeMarkerV3Render = props => {
  const { employee_name, department, team, timestamp, employee_device_name, device_type, employee_id, employee_image_url } = props;
  
  const targetId = generateRandomString(12);
  
  // Get fallback avatar color based on employee ID (for cases where image fails to load)
  const getAvatarColor = (empId) => {
    const colors = ['orange', 'blue', 'teal', 'yellow', 'purple', 'green', 'red'];
    return colors[(empId || 0) % colors.length];
  };

  const avatarColor = getAvatarColor(employee_id);

  return (
    <div
      className={`employee-marker-v3 custom-marker-tooltip-target-${targetId}`}
      onClick={() => props.triggerEmployeeDetailSidebar && props.triggerEmployeeDetailSidebar(props)}
    >
      {employee_image_url ? (
        <div className="employee-avatar-image">
          <img
            src={employee_image_url}
            alt={employee_name || 'Employee'}
            onError={(e) => {
              // Fallback to colored icon if image fails to load
              e.target.style.display = 'none';
              e.target.nextSibling.style.display = 'flex';
            }}
          />
          <div className={`employee-avatar-fallback color-${avatarColor}`} style={{ display: 'none' }}>
            <i className="pi pi-user" />
          </div>
        </div>
      ) : (
        <div className={`employee-avatar-fallback color-${avatarColor}`}>
      <i className="pi pi-user" />
        </div>
      )}
      <Tooltip
        className="custom-marker-tooltip presence-status-tooltip"
        target={`.custom-marker-tooltip-target-${targetId}`}
        baseZIndex={2000}
        autoHide={false}
        position="top"
        event="hover"
      >
        <div className="tooltip-content">
          <div className="tooltip-content-item">
            <div className="text-label">{COMMON_TEXT.EMPLOYEE_NAME}</div>
            <div className="text-value">{employee_name}</div>
          </div>
          <div className="tooltip-content-item">
            <div className="text-label">{COMMON_TEXT.DEPARTMENT}</div>
            <div className="text-value">{department}</div>
          </div>
          <div className="tooltip-content-item">
            <div className="text-label">{COMMON_TEXT.TEAM}</div>
            <div className="text-value">{team}</div>
          </div>
          <div className="tooltip-content-item">
            <div className="text-label">{COMMON_TEXT.DEVICE_NAME}</div>
            <div className="text-value">
              <i style={{ marginRight: '4px' }} className={`pi ${device_type === 'phone' ? 'pi-mobile' : 'pi-desktop'}`}></i>
              {employee_device_name}
            </div>
          </div>
          <div className="tooltip-content-item">
            <div className="text-label">{COMMON_TEXT.LAST_UPDATED_TIME}</div>
            <div className="text-value">
              {format(new Date(timestamp), 'MM月dd日 - HH:mm')}
            </div>
          </div>
        </div>
      </Tooltip>
    </div>
  );
};

// Legacy employee marker (keep for backward compatibility)
export const EmployeeMarkerRender = props => {
  const { employee_name, department, team, timestamp, employee_image_url, employee_device_name, device_type } = props;

  const targetId = generateRandomString(12);

  return (
    <div
      className={`custom-marker custom-marker-tooltip-target-${targetId}`}
      style={{ backgroundColor: 'white', width: 40, height: 40 }}
    >
      <div className="face-image">
        <img
          src={`${employee_image_url}`}
          alt="employee"
          width="40"
          height="40"
        />
      </div>
      <Tooltip
        className="custom-marker-tooltip"
        target={`.custom-marker-tooltip-target-${targetId}`}
        baseZIndex={2000}
        autoHide={false}
        position="top"
        event="hover"
      >
        <div className="display-marker">
          <div className="display-marker__container">
            <div className="text-label">{COMMON_TEXT.EMPLOYEE_NAME}</div>
            <div className="text-value">
              <b>{employee_name}</b>
            </div>
          </div>
          <div className="display-marker__container">
            <div className="text-label">{COMMON_TEXT.DEPARTMENT}</div>
            <div className="text-value">
              <b>{department}</b>
            </div>
          </div>
          <div className="display-marker__container">
            <div className="text-label">{COMMON_TEXT.TEAM}</div>
            <div className="text-value">
              <b>{team}</b>
            </div>
          </div>
          <div className="display-marker__container">
            <div className="text-label">{COMMON_TEXT.DEVICE_NAME}</div>
            <div className="text-value">
              <i style={{ marginTop: '4px' }} className={`pl-1 pr-1 pi ${device_type === 'phone' ? 'pi-mobile' : 'pi-desktop'}`}></i><b>{employee_device_name}</b>
            </div>
          </div>
          <div className="display-marker__container">
            <div className="text-label">{COMMON_TEXT.LAST_UPDATED_TIME}</div>
            <div className="text-value">
              <b>{format(new Date(timestamp), 'MM月dd日 - HH:mm')}</b>
            </div>
          </div>
        </div>
      </Tooltip>
    </div>
  );
};
